<template>
  <div v-click-outside="closeList" class="position-relative">
    <input
      placeholder="جستجو"
      :value="searchQuery"
      @focus="setFocus"
      @input="updateQuery"
      @keyup="
        updateSearchQuery()
        onKeyUp()
      "
      :class="[
        'input_mobile',
        { input: $route.name === 'courses-package' || $route.name === 'course-prerequisites' || $route.name === 'package-prerequisites' || $route.name === 'course-users' },
      ]"
    />
    <template v-if="show && ($route.name === 'courses-package' || $route.name === 'course-prerequisites' || $route.name === 'package-prerequisites')">
      <div v-if="loading" class="list-loading">
        <Loader :loading="loading" />
      </div>
      <div v-if="!loading && list.length === 0" class="list-loading">نتیجه ای یافت نشد!</div>
      <div v-if="list.length" class="list">
        <div v-for="(item, index) in list" :key="index">
          <div :class="['d-flex position-relative item', { __is_not_buy_able: !item.isBuyable && $route.fullPath.includes('universitypackagecourses') }]">
            <div class="image">
              <img v-if="item.image" :src="item.image" />
              <img v-else src="../../../assets/images/brandDefaultPicture.svg" />
            </div>
            <div class="info">
              <div class="title">{{ item.description }}</div>
              <div class="subtitle">{{ item.subDecsription }}</div>
            </div>
            <div
              v-if="
                ($route.fullPath.includes('universitypackagecourses') && item.isBuyable) ||
                $route.name === 'course-prerequisites' ||
                $route.name === 'package-prerequisites' ||
                $route.name === 'courses-package'
              "
              class="list-btn"
              @click="buttonHandle(item)"
            >
              + اضافه کردن
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-if="show && $route.name === 'course-users'">
      <div v-if="loading" class="list-loading">
        <Loader :loading="loading" />
      </div>
      <div v-if="!loading && list.length === 0" class="list-loading">نتیجه ای یافت نشد!</div>
      <div class="scroll">
        <div v-if="list.length" class="user-list">
          <div class="d-flex position-relative item" v-for="(item, index) in list" :key="index" @click="addSelectedUser(item)">
            <div class="user-image">
              <img v-if="item.image" :src="item.image" />
              <img v-else src="../../../assets/images/users/default.png" />
            </div>
            <div class="user">
              <div class="name">
                {{ item.fullName }}
              </div>
              <hr class="custom-hr" v-if="!item.fullName" />
              <div class="phone">
                {{ item.phone }}
              </div>
              <hr v-if="!item.phone" class="custom-hr" />
              <div class="nationalCode">
                {{ item.nationalCode }}
              </div>
              <hr v-if="!item.nationalCode" class="custom-hr" />
            </div>
          </div>
        </div>
        <div v-else class="user-list"></div>
        <div v-if="list.length" class="add-user" @click="$bvModal.show('user-modal')">
          <img src="../../../assets/images/purple-plus.svg" />
          اضافه کردن
        </div>
      </div>
    </template>
    <Toast :showToast="showToast" :title="toastTitle" :error="error" />
    <b-modal id="user-modal" no-close-on-esc hide-footer centered header-close-variant="dark" cancel-title>
      <template #modal-title>کاربر جدید</template>
      <div class="px-3 py-2">
        <BaseText
          :value="model.firstName"
          @input="model.firstName = $event"
          title="نام"
          placeholder="نام"
          required
          :errortext="errorText"
          :showError="submit && !model.firstName"
        />
      </div>
      <div class="px-3 py-2">
        <BaseText
          :value="model.lastName"
          @input="model.lastName = $event"
          title="نام خانوادگی"
          placeholder="نام خانوادگی"
          required
          :errortext="errorText"
          :showError="submit && !model.lastName"
        />
      </div>
      <div class="px-3 py-2">
        <BaseText
          :value="model.phoneNumber"
          @input="model.phoneNumber = $event"
          title="تلفن همراه"
          placeholder="تلفن همراه"
          :maxlength="11"
          required
          :errortext="phoneNumberErrorText || errorText"
          :showError="(submit && !model.phoneNumber) || (submit && phoneNumberError)"
        />
      </div>
      <div class="px-3 py-2">
        <BaseText :value="model.nationalCode" @input="model.nationalCode = $event" title="کدملی" placeholder="کدملی" />
      </div>
      <div class="p-3 py-2 d-flex flex-row justify-content-end">
        <b-button @click="closeModal">انصراف</b-button>
        <Button @click.native="createSearchUser" :loading="submitLoading" text="ثبت" btnClass="upload-btn btn-border" />
      </div>
    </b-modal>
  </div>
</template>

<script>
import { urlQueriesMixins } from '../../../utils/mixins'
import dadbanPackageProvider from '../../../services/dadban/package'
import moocPackageProvider from '../../../services/mooc/package'
import dadbanCourseProvider from '../../../services/dadban/course'
import moocUsersProvider from '../../../services/mooc/user'
import Loader from '../../widgets/loader.vue'
import Toast from '../Toast.vue'
import dadbanUsersProvider from '../../../services/dadban/user'
import BaseText from '../form/formModules/BaseText.vue'
import Button from '../Button.vue'
import skillUpUsersProvider from '../../../services/skillUp/user'
import skillUpCourseProvider from '../../../services/skillUp/course'
import skillUpPackageProvider from '../../../services/skillUp/package'
import userDataProvider from '../../../services/user'
export default {
  name: 'table-header-input',
  components: { Loader, Toast, BaseText, Button },
  mixins: [urlQueriesMixins],
  props: {
    list: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      // searchedValue: '',
      loading: false,
      submitLoading: false,
      show: false,
      notFound: false,
      showToast: false,
      toastTitle: '',
      error: false,
      phoneNumberErrorText: '',
      phoneNumberError: false,
      model: {
        firstName: '',
        lastName: '',
        phoneNumber: '',
        nationalCode: '',
        productId: +this.$route.params.courseId || +this.$route.params.packageId,
        productType: this.$route.params.courseId ? 0 : 1,
      },
      errorText: 'وارد کردن این فیلد الزامی است',
      submit: false,
    }
  },
  watch: {
    '$route.query.query.length'(c) {
      if (c === 0 || !c) {
        if (
          this.$route.name === 'courses-package' ||
          this.$route.name === 'course-prerequisites' ||
          this.$route.name === 'package-prerequisites' ||
          this.$route.name === 'course-users'
        ) {
          this.setFocus()
        }
      }
    },
  },
  beforeDestroy() {
    this.show = false
  },
  methods: {
    onKeyUp() {
      this.$emit('onKeyUp', true)
    },
    updateSearchQuery() {
      this.$store.dispatch('urlQueries/setSearchQuery', this.searchQuery)
    },
    updateQuery(e) {
      this.$store.dispatch('urlQueries/setSearchQuery', e.target.value)
    },
    setFocus() {
      if (
        this.$route.name === 'courses-package' ||
        this.$route.name === 'course-prerequisites' ||
        this.$route.name === 'package-prerequisites' ||
        this.$route.name === 'course-users'
      ) {
        this.loading = true
        this.show = true
        this.$emit('focused')
        setTimeout(() => {
          if (this.list.length === 0) {
            this.loading = false
            this.notFound = true
          }
        }, 3000)
      }
    },
    closeList() {
      this.show = false
    },
    buttonHandle(item) {
      if (this.$route.name === 'course-prerequisites') {
        if (this.$route.path.includes('skillup')) {
          this.addSkillUpCoursePrerequisitesCourse(item)
        } else this.addCoursePrerequisites(item)
      }
      if (this.$route.name === 'package-prerequisites') {
        this.addPackagePrerequisites(item)
      }
      if (this.$route.name === 'courses-package') {
        this.addCoursePackage(item)
      }
    },
    async getPackage(id) {
      let req
      if (this.$route.path.includes('skillup')) req = await skillUpPackageProvider.getPackage(id)
      else req = await moocPackageProvider.getPackage(id)
      if (req.status === 200) this.$route.query.courseLength = req.data.data.output.numberOfAddedCourse
    },
    async addCoursePackage(item) {
      this.show = false
      const body = {
        courseId: item.id,
        packageId: +this.$route.params.packageId,
      }
      if (this.$route.path.includes('skillup')) {
        await skillUpPackageProvider.addPackageCourse(body)
      } else if (this.$route.path.includes('university')) {
        await moocPackageProvider.addPackageCourse(body)
      } else {
        await dadbanPackageProvider.addPackageCourse(body)
      }
      this.$emit('update')
      this.getPackage(+this.$route.params.packageId)
    },
    async addCoursePrerequisites(item) {
      this.show = false
      await dadbanCourseProvider.addCoursePrerequisite({
        courseId: this.$route.params.courseId,
        prerequisiteId: item.id,
      })
      this.$emit('update')
    },
    async addSkillUpCoursePrerequisitesCourse(item) {
      this.show = false
      await skillUpCourseProvider.addCoursePrerequisite({
        courseId: this.$route.params.courseId,
        prerequisiteId: item.id,
      })
      this.$emit('update')
    },

    async addPackagePrerequisites(item) {
      this.show = false
      await dadbanPackageProvider.addPackagePrerequisite({
        packageId: this.$route.params.packageId,
        prerequisiteId: item.id,
      })
      this.$emit('update')
    },
    async addSelectedUser(user) {
      const body = {
        productId: +this.$route.params.courseId || +this.$route.params.packageId,
        productType: this.$route.params.courseId ? 0 : 1,
        userId: user.id,
        firstName: user.firstName,
        lastName: user.lastName,
        image: user.image,
        nationalCode: user.nationalCode,
        phoneNumber: user.phone,
      }
      let req = ''
      if (this.$route.path.includes('skillup')) {
        req = await skillUpUsersProvider.addSearchUser(body)
      } else if (this.$route.path.includes('university')) {
        req = await moocUsersProvider.addSearchUser(body)
      } else {
        req = await dadbanUsersProvider.addSearchUser(body)
      }
      if (req.data.data.isSuccessful) {
        this.$emit('update')
        this.toastTitle = 'کاربر با موفقیت اضافه شد'
        this.$route.query.usersUpdate = 1
        this.showToast = true
      } else {
        this.error = true
        this.toastTitle = 'کاربر قبلا اضافه شده است'
        this.showToast = true
      }

      setTimeout(() => {
        this.showToast = false
        this.error = false
      }, 5000)
      this.show = false
    },
    async createSearchUser() {
      this.submit = true
      if (!this.model.firstName || !this.model.lastName || !this.model.phoneNumber) {
        return false
      } else if (this.model.phoneNumber) {
        const mobileNumberRegex = /^09(1[0-9]|9[0-2]|2[0-2]|0[1-5]|41|3[0,3,5-9])\d{7}$/
        const checkMobileNumber = mobileNumberRegex.test(this.model.phoneNumber)
        if (!checkMobileNumber) {
          this.phoneNumberError = true
          this.phoneNumberErrorText = 'شماره همراه کاربر را صحیح وارد نمایید .'
          return false
        }
      }
      this.submitLoading = true
      try {
        const req = await userDataProvider.addNewUser({ ...this.model, mobile: this.model.phoneNumber })

        this.submitLoading = false

        this.$emit('update')
        this.addSelectedUser({ ...this.model, phone: this.model.phoneNumber })
        this.toastTitle = 'کاربر با موفقیت اضافه شد'
        this.showToast = true
        this.$bvModal.hide('user-modal')

        this.model['productId'] = +this.$route.params.courseId || +this.$route.params.packageId
        this.model['productType'] = this.$route.params.courseId ? 0 : 1

        this.submit = false
      } catch (error) {
        this.submitLoading = false
        this.error = true
        this.toastTitle = error.response.data.message
        this.showToast = true

        this.model['productId'] = +this.$route.params.courseId || +this.$route.params.packageId
        this.model['productType'] = this.$route.params.courseId ? 0 : 1

        setTimeout(() => {
          this.showToast = false
          this.error = false
        }, 5000)
      }
    },
    closeModal() {
      this.$bvModal.hide('user-modal')
      this.submitLoading = false
      this.submit = false
      this.toastTitle = ''
      this.showToast = false
      this.error = false
      this.model = {}
    },
  },
}
</script>

<style lang="scss" scoped>
input {
  border: 1px solid #e8e8e8;
  box-sizing: border-box;
  border-radius: 3px;
  outline: none;
  width: 250px;
  height: 27px;
}

input::placeholder {
  padding: 0 12px;
}

.input {
  width: 434px;
}

.scroll {
  background: #ffffff;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
  border-radius: 2px;
  height: 220px;
  width: 433px;
  // padding: 10px;
  padding-left: 0;
  position: absolute;
  top: 33px;
  right: 0;
  z-index: 100;
}

.user-list {
  overflow-y: auto;
  height: 170px;
}

.list {
  background: #ffffff;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
  border-radius: 2px;
  overflow-y: auto;
  height: 220px;
  width: 433px;
  // padding: 10px;
  padding-left: 0;
  position: absolute;
  top: 33px;
  right: 0;
  z-index: 100;
}

.image {
  height: 42px;
  width: 62px;
  border-radius: 2px;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
  }
}

.info {
  position: relative;
  display: flex;
  flex-direction: column;
  margin: 0 10px 0 0;

  .title {
    font-size: 14px;
    width: 250px;
  }

  .subtitle {
    font-size: 12px;
    margin-top: 2px;
  }
}

.list-btn {
  position: absolute;
  left: 5px;
  top: 10px;
  text-align: left;
  font-size: 11px;
  color: #556ee6;
  cursor: pointer;
}

.list-loading {
  @extend .list;
  display: grid;
  place-items: center;
}

.item {
  padding: 15px 10px;

  &:hover {
    background: rgba(85, 110, 230, 0.1);
  }
}

.user {
  display: flex;
  width: 100%;
  justify-content: center;
  cursor: pointer;

  .name {
    position: relative;
    top: 5px;
    margin-right: 10px;
    width: 50%;
  }

  .phone,
  .nationalCode {
    width: 25%;
    color: #999696;
    text-align: center;
    margin-right: 50px;
    position: relative;
    top: 5px;
  }
}

.user-image {
  img {
    width: 28px;
    height: 28px;
    border-radius: 100%;
  }
}

.add-user {
  font-weight: 400;
  font-size: 13px;
  line-height: 21px;
  color: #556ee6;
  cursor: pointer;
  font-weight: bold;
  padding: 14px;
  border-top: 1px solid #e8e8e8;

  img {
    margin-left: 10px;
  }
}

.upload-btn {
  margin-right: 10px !important;
  background: #556ee6 !important;
  border-radius: 4px !important;
  color: white !important;
  padding: 8px 28px !important;
}

.custom-hr {
  margin: 0 !important;
  bottom: 10px;
  position: relative;
  top: 13px;
  height: 2px;
  background-color: #000 !important;
  opacity: 0.3;
  width: 50px;
  left: 30px;
}

.__is_not_buy_able {
  opacity: 0.5;
  cursor: not-allowed;
}
@media (min-width: 100px) {
  .input_mobile {
    width: 195px;
  }
}

@media (min-width: 300px) {
  .input_mobile {
    width: 250px;
  }
}
</style>
